/* Slow but memory safe array conversion. */
const uint8ToUint32Array = (arr: Uint8Array) => {
    if (arr.byteLength % 4 !== 0) {
        console.error(
            "Error: The input array's byteLength is",
            arr.byteLength,
            "which is not a multiple of 4. Cannot create a valid Uint32Array."
        )
    }

    const slicedBuffer = arr.buffer.slice(arr.byteOffset, arr.byteOffset + arr.byteLength)

    const u32Arr = new Uint32Array(slicedBuffer)
    return u32Arr
}

const uint32ToUint8Array = (arr: Uint32Array) => {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength)
}

export { uint8ToUint32Array, uint32ToUint8Array }
